// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"c5b893e4","558":"a4096b12","579":"2aea8a1b","654":"f6d0096a","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};